﻿import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedConnection,
  setSchemaCollectionDocuments,
} from "@/features/connections/integrationSlice";
import { Container } from "@mui/material";
import TransactionSetSettingsGrid from "./TransactionSetSettingsGrid";
import axios from "@/features/axiosHelper";

const TransactionSetSettings = () => {
  const dispatch = useDispatch();

  const selectedConnection = useSelector(selectSelectedConnection);

  useEffect(() => {
    getSchemaCollectionInfo();
  }, [selectedConnection.ConnectionId]);

  const getSchemaCollectionInfo = () => {
    axios
      .get("/connectionartifactschema", {
        params: {
          connectionId: selectedConnection.ConnectionId,
        },
      })
      .then((response) => {
        dispatch(
          setSchemaCollectionDocuments({
            schemaCollectionDocuments: response.data,
          })
        );
      })
      .catch((error) => {
        console.error("Error fetching artifact data: ", error);
      });
  };

  return (
    <Container>
      <TransactionSetSettingsGrid />
    </Container>
  );
};
export default TransactionSetSettings;
